export default "__VITE_ASSET__Cw1HDs$q__"